import { render, staticRenderFns } from "./ShareArticleAudit.vue?vue&type=template&id=7bd4d2fd&scoped=true"
import script from "./ShareArticleAudit.vue?vue&type=script&lang=js"
export * from "./ShareArticleAudit.vue?vue&type=script&lang=js"
import style0 from "./ShareArticleAudit.vue?vue&type=style&index=0&id=7bd4d2fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd4d2fd",
  null
  
)

export default component.exports